module.exports = __webpack_public_path__ + "img/top_menu_market.124ea2ee.webp";